const businessEvents = require('client/lib/business-events')

module.exports = {
  'track-click': function () {
    const $this = $(this)
    const trackEvent = $this.attr('data-track-event')
    let trackData
    try {
      trackData = JSON.parse($this.attr('data-track-data'))
    } catch (exception) {
      // do nothing
    }
    businessEvents.trackSegment(trackEvent, trackData)
  }
}
